import React from 'react';
import ContractualAccountsSection from 'features/contractualAccounts/sections/ContractualAccountsSection';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import { useTranslation } from 'react-i18next';
import ContractualAccountDetail from 'features/contractualAccounts/pages/ContractualAccountDetail';
import ContractDetailMainPage from 'features/contracts/pages/ContractDetailMainPage';
import FuelingContractDetailPage from 'features/contracts/pages/fueling/FuelingContractDetailPage';
interface Props {
  
}

const ContractualAccounts = (props: Props) => {
  let match = useRouteMatch();
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <Switch>
      <Route path={`${match.path}/fueling-contracts/:fuelingContractId`} component={FuelingContractDetailPage} />
      <Route path={`${match.path}/contracts/:id`} component={ContractDetailMainPage} />
      <Route path={`${match.path}/:contractualAccountId`} component={ContractualAccountDetail} />
      <Route path={match.path}>
        <Header title={t("contractualAccounts.title")} includeBreadcrumbs />
        <ModuleContent>
          <ContractualAccountsSection />
        </ModuleContent>
      </Route>
    </Switch>
  )
}

export default ContractualAccounts;
